'use client';
// `window` exists in browser tabs; Web Worker scopes (including extension
// service workers) expose `importScripts` on `globalThis`. If neither is
// present we are in Node.js and this module should not have been imported.
if (typeof window === 'undefined' && !('importScripts' in globalThis) && !process.env.VITEST) {
    throw new Error('pplx/frontend/fetcher/browser must only be imported in browser environments. ' +
        'Use pplx/frontend/fetcher/node for server-side code.');
}
import { getAccountHeaders } from '#pplx/frontend/browser-storage/activeAccount.js';
import { applyConnectorGoProxyRoute } from '#pplx/frontend/fetcher/connectorRouting.js';
import { WEB_VERSION } from '#pplx/frontend/fetcher/constants.js';
import { _addSourceVersionQueryParams, sseStream as coreSseStream, fetchWithTimeout, } from '#pplx/frontend/fetcher/core.js';
import { joinHostAndPath } from '#pplx/frontend/fetcher/network.js';
import { getApiClient } from '#pplx/frontend/fetcher/utils.js';
export const mergeAuthedHeaders = ({ clientHeaders, isMobile, isWindowsApp, }) => {
    const apiClient = getApiClient({ isMobile, isWindowsApp });
    const clientHeadersClass = clientHeaders instanceof Headers
        ? new Headers(clientHeaders)
        : new Headers(Object.entries(clientHeaders ?? {})
            .filter((entry) => entry[1] !== undefined)
            .map(([k, v]) => [k, Array.isArray(v) ? v.join(', ') : v]));
    const headers = new Headers({
        'X-App-ApiClient': apiClient,
        'X-App-ApiVersion': WEB_VERSION,
        ...getAccountHeaders(),
    });
    clientHeadersClass.forEach((value, key) => {
        headers.set(key, value);
    });
    return headers;
};
/**
 * Similar to `httpFetch` but with PPLX-specific headers & auth.
 * You also can only make calls to the same origin.
 * @param param0
 * @returns
 */
export async function authedHttpFetch({ urlPath, timeoutMs, method, body, headers: headersParam, baseUrlOverride, includeCredentials, keepalive, redirect, numRetries, backOffTime, reason, signal, normalizedPath, shouldNotAddSourceVersionQueryParams, appDomain, }) {
    const isMobile = navigator.userAgent.includes('Mobile');
    const isWindowsApp = navigator.userAgent.includes('WindowsApp');
    const headers = mergeAuthedHeaders({
        clientHeaders: headersParam,
        isMobile,
        isWindowsApp,
    });
    const options = {
        headers,
        redirect,
        credentials: includeCredentials ? 'include' : 'same-origin',
        keepalive,
    };
    const baseUrl = baseUrlOverride ?? window.location.origin;
    const fullUrl = shouldNotAddSourceVersionQueryParams
        ? joinHostAndPath(baseUrl, urlPath)
        : _addSourceVersionQueryParams(joinHostAndPath(baseUrl, urlPath));
    if (typeof window !== 'undefined') {
        applyConnectorGoProxyRoute(new URL(fullUrl), window.location.origin, headers);
    }
    return fetchWithTimeout({
        resource: fullUrl,
        options,
        timeoutMs,
        method,
        body,
        signal,
        numRetries,
        backOffTime,
        reason,
        normalizedPath,
        appDomain,
    });
}
export function sseStream({ url: path, headers, ...opts }) {
    const url = new URL(path, window.location.origin);
    return coreSseStream({
        url,
        headers: { ...getAccountHeaders(), ...headers },
        ...opts,
    });
}
//# sourceMappingURL=browser.js.map